import { OfertasState, OfertasActionTypes, SET_OFERTAS } from './types';

const initialState: OfertasState = {
    ofertas: []
};

export function ofertasReducer(
    state = initialState,
    action: OfertasActionTypes
): OfertasState {
    switch (action.type) {
        case SET_OFERTAS:
            return { ...state, ofertas: action.payload };
        default:
            return state;
    }
}